import SkeletonTable from "@/components/SkeletonTable";
import { useTahun } from "@/hooks/useTahun";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";

const getListRuangCbtDetail = async (
  idsPeriodeParams?: string,
  isPenuhParams?: string,
  tanggalCbtParams?: string,
  jenisRuangParams?: string,
  tahunParams?: string,
) => {
  const response = await api.get("/setting/ruang-cbt-detail/index", {
    params: {
      ids_sys_periode: idsPeriodeParams,
      is_penuh: isPenuhParams,
      tanggal_cbt: tanggalCbtParams,
      jenis_ruang: jenisRuangParams,
      tahun: tahunParams,
    },
    withCredentials: true,
  });
  return response.data?.data;
};

export default function SettingRuangCbtDetailPage() {
  const [searchParams] = useSearchParams();
  const idsPeriodeParams = searchParams.get("ids_sys_periode") || "";
  const isPenuhParams = searchParams.get("is_penuh") || "";
  const tanggalCbtParams = searchParams.get("tanggal_cbt") || "";
  const jenisRuangParams = searchParams.get("jenis_ruang") || "";

  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listRuangCbtDetail",
      idsPeriodeParams,
      isPenuhParams,
      tanggalCbtParams,
      jenisRuangParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListRuangCbtDetail(
        idsPeriodeParams,
        isPenuhParams,
        tanggalCbtParams,
        jenisRuangParams,
        selectedTahun?.label,
      ),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
